import { fetchWallets, chainsForNamespace } from "./api";
import { mapWallet } from "./mapWallet";
// Slugified names of wallets to exclude (duplicates / unwanted entries).
const SLUGS_TO_FILTER = ['okx-wallet-1', 'ready', 'yowallet', 'safewallet'];
export async function resolveWalletConnectWallets(opts = {}) {
    const chains = opts.chainIds?.join(',')
        || (opts.namespace ? chainsForNamespace(opts.namespace) : undefined);
    const projectId = opts.projectId || '6113382c2e587bff00e2b5c3d68531f3';
    const response = await fetchWallets({
        page: opts.page ?? 1,
        entries: opts.entries ?? 40,
        chains: chains || undefined,
        search: opts.search,
        projectId,
    });
    const wallets = response.data
        .map((wallet) => mapWallet(wallet, projectId))
        .filter(w => !SLUGS_TO_FILTER.includes(w.id));
    return {
        wallets,
        totalCount: response.count,
        nextPage: response.nextPage,
    };
}
